import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseRemoveFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}


const useBillingEventRemoveFiscalDocument = ({ id, onSuccess, onError }: UseRemoveFiscalDocument) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['billingEventRemoveFiscalDocument'],
    mutationFn: async () => {
      return await privateAxios.put(`/billing/events/${id}/remove_fiscal_document`)
    },
    onSuccess,
    onError
  })
}

export default useBillingEventRemoveFiscalDocument
